<template>
  <b-container class="my-5 my-md-6">
    <b-row align-h="center">
      <b-col class="col-auto">
        <h3 class="heading text-primary display-4">Messages</h3>
      </b-col>
    </b-row>
    <b-row
      style="position: relative"
      align-h="center"
      align-v="center"
      class="mt-6"
    >
      <b-col>
        <MessageCard class="message-card--support">
          <template #title> Chat with Patient Services </template>

          <template #body>
            Have a question about your membership, packages or billing? Patient
            services is here to help!
          </template>

          <template #badge>
            <b-badge
              class="badge badge--number"
              v-if="unreadAdminMessagesCount > 0"
              pill
              variant="primary"
            >
              {{ unreadAdminMessagesCount }}
            </b-badge>
          </template>

          <template #action>
            <b-button
              pill
              variant="info"
              size="lg"
              class="px-5"
              @click="routeTo('message-admin')"
            >
              Chat now
            </b-button>
          </template>
        </MessageCard>

        <MessageCard class="message-card--doctor">
          <template #title> Contact Your Physician </template>

          <template #body>
            Message your Winona doctor here about changes in medication,
            treatment, or health.
          </template>

          <template #action>
            <b-button
              pill
              variant="outline-dark"
              size="lg"
              class="btn-action px-5"
              @click="routeTo('message-doctor')"
            >
              Contact Doctor
            </b-button>
          </template>

          <template #badge>
            <b-badge
              class="badge badge--text"
              pill
              variant="primary"
              v-if="currentUser.needspatientreply"
            >
              reply needed
            </b-badge>

            <b-badge
              class="badge badge--number"
              v-if="unreadMessagesCount > 0"
              pill
              variant="primary"
            >
              {{ unreadMessagesCount }}
            </b-badge>
          </template>
        </MessageCard>
      </b-col>
      <div
        v-if="unreadMessagesCount > 0"
        class="position-absolute"
        style="top: 1rem; right: 2rem; font-size: 1.5rem"
      >
        <b-badge
          class="d-flex align-items-center justify-content-center"
          style="height: 30px; width: 30px"
          pill
          variant="primary"
        >
          {{ unreadMessagesCount }}
        </b-badge>
      </div>
    </b-row>
  </b-container>
</template>

<script>
// libs
import { mapState } from "vuex";

// components
import MessageCard from "@/components/messages/MessageCard.vue";

export default {
  components: {
    MessageCard,
  },

  computed: {
    ...mapState("message", ["unreadMessagesCount", "unreadAdminMessagesCount"]),
    ...mapState("user", ["currentUser"]),
  },

  methods: {
    routeTo(routeName) {
      this.$router.push({ name: routeName });
    },
  },

  async created() {
    this.$store.dispatch("user/getUser");
    this.$store.dispatch("message/getAdminUnreadMessageCount");
    this.$store.dispatch("message/getUnreadMessageCount");
  },
};
</script>

<style lang="scss" scoped>
.message-card {
  .badge {
    font-size: 14px;
    border: 1px solid transparent;
    @include flex-center();

    &--number {
      @include wh(28px);
    }

    &--text {
      height: 30px;
    }
  }

  &--support {
    background-color: #f5f2ff;
  }

  &--doctor {
    background-color: #eff0f1;

    ::v-deep .badge {
      &--number {
        background-color: #f58c42;
        text-transform: uppercase;
      }

      &--text {
        background-color: transparent;
        border-color: #f58c42;
        color: #f58c42;
        font-size: 14px;
        text-transform: uppercase;
        padding-inline: 15px;
      }
    }

    ::v-deep .btn-action.btn {
      background-color: transparent;
      color: #020203 !important;
    }
  }
}
</style>
